import { Box, Text } from '@chakra-ui/react';
import { ExperienceItem } from '../components/ExperienceItem';
import PageContainer from '../components/PageContainer';
import { FULL_COMPANIES } from '../constants/companies';
import { t } from '../locales/locales';

export default function Experiences() {
  return (
    <PageContainer>
      <Box
        alignItems="center"
        justifyContent={'center'}
        display="flex"
        flexDirection="column"
      >
        <Text
          color="white"
          fontSize={'3xl'}
          textAlign={'center'}
          fontWeight={'medium'}
          mb={5}
          mt={8}
        >
          {t('experiences')}
        </Text>
        <Text
          fontSize={'lg'}
          textAlign={'center'}
          fontWeight={'thin'}
          color="gray.400"
          mb={5}
          mt={2}
          maxWidth={{ base: 300, md: 300, lg: 600 }}
        >
          {t('experiencesSummary')}
        </Text>
      </Box>
      {FULL_COMPANIES.map((experience) => (
        <ExperienceItem key={experience.id} experience={experience} />
      ))}
    </PageContainer>
  );
}
